/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceBase,
  BalanceBaseOptional,
  BalanceBaseMetaI,
  BalanceBaseTrackedI,
} from "./balance-base";
import { BalanceBaseTracked, BalanceBaseMeta } from "./balance-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceRef,
  BalanceRefOptional,
  BalanceRefMetaI,
  BalanceRefTrackedI,
} from "./balance-ref";
import { BalanceRefTracked, BalanceRefMeta } from "./balance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceType,
  BalanceTypeOptional,
  BalanceTypeMetaI,
  BalanceTypeTrackedI,
} from "./balance-type";
import { BalanceTypeTracked, BalanceTypeMeta } from "./balance-type";

/**
 *
 * @export
 * @interface BalanceBaseDTO
 */
export interface BalanceBaseDTOOptional extends BalanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof BalanceBaseDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof BalanceBaseDTO
   */
  balanceName?: string;
  /**
   *
   * @type {string}
   * @memberof BalanceBaseDTO
   */
  balanceExpirationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof BalanceBaseDTO
   */
  balanceAccountNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof BalanceBaseDTO
   */
  balanceIsPrivate?: boolean;
  /**
   *
   * @type {BalanceType}
   * @memberof BalanceBaseDTO
   */
  balanceType?: BalanceType;
}

export interface BalanceBaseDTO
  extends BalanceBaseDTOOptional, BalanceBase, BalanceRef {
  /**
   *
   * @type {number}
   * @memberof BalanceBaseDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof BalanceBaseDTO
   */
  balanceName?: string;
  /**
   *
   * @type {string}
   * @memberof BalanceBaseDTO
   */
  balanceExpirationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof BalanceBaseDTO
   */
  balanceAccountNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof BalanceBaseDTO
   */
  balanceIsPrivate?: boolean;
  /**
   *
   * @type {BalanceType}
   * @memberof BalanceBaseDTO
   */
  balanceType: BalanceType;
}

export interface BalanceBaseDTOTrackedI extends BalanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof BalanceBaseDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceBaseDTO
   */
  balanceName?: string;
  balanceNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceBaseDTO
   */
  balanceExpirationDate?: Date;
  balanceExpirationDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceBaseDTO
   */
  balanceAccountNumber?: string;
  balanceAccountNumberIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceBaseDTO
   */
  balanceIsPrivate?: boolean;
  balanceIsPrivateIsSet: boolean;
  /**
   *
   * @type {BalanceType}
   * @memberof BalanceBaseDTO
   */
  balanceType?: BalanceType;
  balanceTypeIsSet: boolean;
}

transformDatesMap.set("BalanceBaseDTO", function (model: BalanceBaseDTO) {
  if (typeof model.balanceExpirationDate == "string")
    model.balanceExpirationDate = new Date(model.balanceExpirationDate);
});

export type BalanceBaseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  balanceName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  balanceExpirationDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  balanceAccountNumber: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  balanceIsPrivate: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  balanceType: PropertyMeta<BalanceTypeMetaI>;
}>;

export var BalanceBaseDTOMeta: BalanceBaseDTOMetaI = {} as BalanceBaseDTOMetaI;
BalanceBaseDTOMeta = typeMeta("BalanceBaseDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  balanceName: propertyMeta(
    "balanceName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  balanceExpirationDate: propertyMeta(
    "balanceExpirationDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  balanceAccountNumber: propertyMeta(
    "balanceAccountNumber",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  balanceIsPrivate: propertyMeta(
    "balanceIsPrivate",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  balanceType: propertyMeta("balanceType", false, true, false, BalanceTypeMeta),
});

const metaI = BalanceBaseDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([BalanceRefMeta]);
  metaI.assignId.inheritedFrom = BalanceRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([BalanceBaseMeta]);
  metaI.assignId.inheritedFrom = BalanceBaseMeta.assignId;
  metaI.balanceName.inheritedFrom = BalanceBaseMeta.balanceName;
  metaI.balanceExpirationDate.inheritedFrom =
    BalanceBaseMeta.balanceExpirationDate;
  metaI.balanceAccountNumber.inheritedFrom =
    BalanceBaseMeta.balanceAccountNumber;
  metaI.balanceIsPrivate.inheritedFrom = BalanceBaseMeta.balanceIsPrivate;
  metaI.balanceType.inheritedFrom = BalanceBaseMeta.balanceType;
});

export class BalanceBaseDTOTracked
  extends BalanceBaseTracked
  implements BalanceBaseDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  balanceName__I?: string = undefined;
  balanceNameIsSet: boolean = false;
  set balanceName(v: undefined | string) {
    if (v !== undefined) {
      this.balanceName__I = v;
      this.balanceNameIsSet = true;
    } else {
      this.balanceName__I = v || undefined;
      this.balanceNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceName() {
    return this.balanceName__I;
  }
  balanceExpirationDate__I?: Date = undefined;
  balanceExpirationDateIsSet: boolean = false;
  set balanceExpirationDate(v: undefined | Date) {
    if (v !== undefined) {
      this.balanceExpirationDate__I = v;
      this.balanceExpirationDateIsSet = true;
    } else {
      this.balanceExpirationDate__I = v || undefined;
      this.balanceExpirationDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceExpirationDate() {
    return this.balanceExpirationDate__I;
  }
  balanceAccountNumber__I?: string = undefined;
  balanceAccountNumberIsSet: boolean = false;
  set balanceAccountNumber(v: undefined | string) {
    if (v !== undefined) {
      this.balanceAccountNumber__I = v;
      this.balanceAccountNumberIsSet = true;
    } else {
      this.balanceAccountNumber__I = v || undefined;
      this.balanceAccountNumberIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceAccountNumber() {
    return this.balanceAccountNumber__I;
  }
  balanceIsPrivate__I?: boolean = undefined;
  balanceIsPrivateIsSet: boolean = false;
  set balanceIsPrivate(v: undefined | boolean) {
    if (v !== undefined) {
      this.balanceIsPrivate__I = v;
      this.balanceIsPrivateIsSet = true;
    } else {
      this.balanceIsPrivate__I = v || undefined;
      this.balanceIsPrivateIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceIsPrivate() {
    return this.balanceIsPrivate__I;
  }
  balanceType__I?: BalanceType = undefined;
  balanceTypeIsSet: boolean = false;
  set balanceType(v: undefined | BalanceType) {
    if (v !== undefined) {
      this.balanceType__I = v;
      this.balanceTypeIsSet = true;
    } else {
      this.balanceType__I = v || undefined;
      this.balanceTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get balanceType() {
    return this.balanceType__I;
  }
  constructor(config?: BalanceBaseDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: BalanceBaseDTOOptional,
    options?: AssignOptions,
  ): BalanceBaseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.balanceName &&
      this.balanceNameApplyFilter(optionsRequired.filter)
    ) {
      this.balanceName = config.balanceName;
      if (optionsRequired.unassign) this.balanceNameIsSet = false;
      else this.balanceNameIsSet = true;
    }
    if (
      config.balanceExpirationDate &&
      this.balanceExpirationDateApplyFilter(optionsRequired.filter)
    ) {
      this.balanceExpirationDate = config.balanceExpirationDate;
      if (optionsRequired.unassign) this.balanceExpirationDateIsSet = false;
      else this.balanceExpirationDateIsSet = true;
    }
    if (
      config.balanceAccountNumber &&
      this.balanceAccountNumberApplyFilter(optionsRequired.filter)
    ) {
      this.balanceAccountNumber = config.balanceAccountNumber;
      if (optionsRequired.unassign) this.balanceAccountNumberIsSet = false;
      else this.balanceAccountNumberIsSet = true;
    }
    if (
      config.balanceIsPrivate &&
      this.balanceIsPrivateApplyFilter(optionsRequired.filter)
    ) {
      this.balanceIsPrivate = config.balanceIsPrivate;
      if (optionsRequired.unassign) this.balanceIsPrivateIsSet = false;
      else this.balanceIsPrivateIsSet = true;
    }
    if (
      config.balanceType &&
      this.balanceTypeApplyFilter(optionsRequired.filter)
    ) {
      this.balanceType = config.balanceType;
      if (optionsRequired.unassign) this.balanceTypeIsSet = false;
      else this.balanceTypeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): BalanceBaseDTOTrackedI {
    const cloned = {} as BalanceBaseDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.balanceNameIsSetDeep() &&
      this.balanceNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceNameIsSet = true;
      cloned.balanceName = this.balanceName;
    } else {
      //cloned.balanceNameIsSet = false
    }
    if (
      this.balanceExpirationDateIsSetDeep() &&
      this.balanceExpirationDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceExpirationDateIsSet = true;
      cloned.balanceExpirationDate = this.balanceExpirationDate;
    } else {
      //cloned.balanceExpirationDateIsSet = false
    }
    if (
      this.balanceAccountNumberIsSetDeep() &&
      this.balanceAccountNumberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceAccountNumberIsSet = true;
      cloned.balanceAccountNumber = this.balanceAccountNumber;
    } else {
      //cloned.balanceAccountNumberIsSet = false
    }
    if (
      this.balanceIsPrivateIsSetDeep() &&
      this.balanceIsPrivateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceIsPrivateIsSet = true;
      cloned.balanceIsPrivate = this.balanceIsPrivate;
    } else {
      //cloned.balanceIsPrivateIsSet = false
    }
    if (
      this.balanceTypeIsSetDeep() &&
      this.balanceTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceTypeIsSet = true;
      cloned.balanceType = this.balanceType;
    } else {
      //cloned.balanceTypeIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): BalanceBaseDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.balanceNameApplyFilter(filter)) this.balanceNameIsSet = false;

    if (!this.balanceExpirationDateApplyFilter(filter))
      this.balanceExpirationDateIsSet = false;

    if (!this.balanceAccountNumberApplyFilter(filter))
      this.balanceAccountNumberIsSet = false;

    if (!this.balanceIsPrivateApplyFilter(filter))
      this.balanceIsPrivateIsSet = false;

    if (!this.balanceTypeApplyFilter(filter)) this.balanceTypeIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceBaseDTOMeta.assignId,
      BalanceBaseDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  balanceNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceBaseDTOMeta.balanceName,
      BalanceBaseDTOMeta,
      this.balanceName,
      this,
    );
  }
  balanceNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceNameIsSet && this.balanceNameApplyFilter(filter))
      return true;

    return false;
  }
  balanceExpirationDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceBaseDTOMeta.balanceExpirationDate,
      BalanceBaseDTOMeta,
      this.balanceExpirationDate,
      this,
    );
  }
  balanceExpirationDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceExpirationDateIsSet &&
      this.balanceExpirationDateApplyFilter(filter)
    )
      return true;

    return false;
  }
  balanceAccountNumberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceBaseDTOMeta.balanceAccountNumber,
      BalanceBaseDTOMeta,
      this.balanceAccountNumber,
      this,
    );
  }
  balanceAccountNumberIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceAccountNumberIsSet &&
      this.balanceAccountNumberApplyFilter(filter)
    )
      return true;

    return false;
  }
  balanceIsPrivateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceBaseDTOMeta.balanceIsPrivate,
      BalanceBaseDTOMeta,
      this.balanceIsPrivate,
      this,
    );
  }
  balanceIsPrivateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceIsPrivateIsSet && this.balanceIsPrivateApplyFilter(filter))
      return true;

    return false;
  }
  balanceTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceBaseDTOMeta.balanceType,
      BalanceBaseDTOMeta,
      this.balanceType,
      this,
    );
  }
  balanceTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceTypeIsSet && this.balanceTypeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.balanceNameIsSetDeep(filter)) return true;
    if (this.balanceExpirationDateIsSetDeep(filter)) return true;
    if (this.balanceAccountNumberIsSetDeep(filter)) return true;
    if (this.balanceIsPrivateIsSetDeep(filter)) return true;
    if (this.balanceTypeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
